import { getSupabase } from "./supabase.js";

/* Mesma exigência de senha para convite e para recuperação. */
export function validatePortalPassword(password, confirmation) {
  const value = String(password || "");
  if (value.length < 12 || !/[a-z]/.test(value) || !/[A-Z]/.test(value) || !/\d/.test(value)) {
    throw new Error("Use no mínimo 12 caracteres, com maiúscula, minúscula e número.");
  }
  if (value !== confirmation) throw new Error("As senhas não coincidem.");
  return value;
}

/* Nome anterior, mantido como alias para não quebrar quem já importa. */
export const validateInvitePassword = validatePortalPassword;

export function createInviteAcceptanceController({ getSession, updateUser, signOut, navigate = () => {} }) {
  return {
    async initialize() {
      const { data, error } = await getSession();
      if (error || !data?.session?.user) throw new Error("Este convite é inválido ou expirou.");
      return data.session.user;
    },
    async submit({ password, confirmation }) {
      const validPassword = validatePortalPassword(password, confirmation);
      const { data, error } = await updateUser({ password: validPassword });
      if (error || !data?.user) throw new Error("Não foi possível definir a senha. Solicite um novo convite.");
      await signOut({ scope: "local" });
      navigate("index.html?convite=aceito");
    },
  };
}

export function mountInviteAcceptance({ document: documentRef = document, client, navigate = (target) => window.location.replace(target) } = {}) {
  const form = documentRef.getElementById("inviteAcceptanceForm");
  if (!form) return null;
  const supabase = client || getSupabase();
  const status = documentRef.getElementById("inviteStatus");
  const submit = documentRef.getElementById("inviteSubmit");
  const controller = createInviteAcceptanceController({
    getSession: () => supabase.auth.getSession(),
    updateUser: (attributes) => supabase.auth.updateUser(attributes),
    signOut: (options) => supabase.auth.signOut(options),
    navigate,
  });
  controller.initialize().then(() => { status.textContent = "Convite confirmado. Defina sua senha de acesso."; }).catch(() => {
    status.textContent = "Este convite é inválido ou expirou. Solicite um novo convite ao administrador.";
    status.classList.add("is-error");
    form.hidden = true;
  });
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    submit.disabled = true;
    status.classList.remove("is-error");
    status.textContent = "Salvando sua senha…";
    try {
      await controller.submit({ password: documentRef.getElementById("invitePassword").value, confirmation: documentRef.getElementById("invitePasswordConfirmation").value });
    } catch (error) {
      status.textContent = error.message;
      status.classList.add("is-error");
      submit.disabled = false;
    }
  });
  return controller;
}

if (typeof document !== "undefined") mountInviteAcceptance();
